export const TextEffectsNeonSignViewerType =
  'wixui.TextEffectsNeonSign' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsNeonSign-container',
    text: 'TextEffectsNeonSign-text',
  },
} as const;
